module.exports = __webpack_public_path__ + "img/ring_r_c_null_null.ba296e3e.png";